// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__KNo3D","is_mobile":"Banner_is_mobile__idqYh","banner_text":"Banner_banner_text__vUBOk"};